import React from 'react';
import T from 'prop-types';

import StoreSummary from './StoreSummary';
import SubmissionsTable from './SubmissionsTable';
import SubmissionComparison from './SubmissionComparison';
import TopCategories from './TopCategories';
import PublishersSubmissions from './PublishersSubmissions';

const StoreColumn = ({ data }) => (
  <div className="col-xxs-12 col-xl-6">
    <section className="card card-sm b-a b-rds">
      <div className="m-b-lg">
        <StoreSummary store={data.store} summary={data.summary} />
      </div>
      <h3 className="text-sm m-b-sm text-xxs-center">Total Submissions</h3>
      <div className="b-b" />
      <div className="m-b-lg">
        <SubmissionsTable data={data.apps_submissions} />
      </div>
      <div className="m-b-lg">
        <SubmissionComparison months={data.submission_comparison} />
      </div>
      <div className="m-b-lg">
        <TopCategories data={data.top_categories} />
      </div>
      <div className="m-b-lg">
        <PublishersSubmissions data={data.publishers} />
      </div>
    </section>
  </div>
);

StoreColumn.propTypes = {
  data: T.shape({
    store: T.string,
    summary: T.object,
    apps_submissions: T.object,
    submission_comparison: T.array,
    top_categories: T.object,
    publishers: T.object,
  }).isRequired,
};

export default StoreColumn;
